export default "__VITE_ASSET__3eee20f7__"